// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications_container__3PwMq","listItem":"Notifications_listItem__3PyJW","noResults":"Notifications_noResults__2nK6c"};